import { Text } from '@/shared/ui/core';
import styles from './remaining-checks.module.scss';


type RemainingChecksProps = {
    checks_number: number;
    /** Остаток общего пула команды (owner/admin) вместо личного остатка. */
    isTeam?: boolean;
};


export const RemainingChecks = ({ checks_number = 0, isTeam = false }: RemainingChecksProps) => {
    return (
        <div className={ styles.root }>
            <Text
                tone='primary'
                weight='semibold'
                className={ styles.number }
            >
                { checks_number }
            </Text>

            <Text
                tone='primary'
                weight='medium'
                className={ styles.text }
            >
                {
                    isTeam
                        ? <>Remaining<br/>team checks</>
                        : <>Remaining<br/>checks</>
                }
            </Text>
        </div>
    );
};
